<p-dialog #dialog appendTo="body" [header]="header" [(visible)]="visible" [modal]="true"
  [resizable]="false" (onHide)="hide()" [style]="{'width': '1000px', 'height': '560px'}"
  [contentStyle]="{'overflow': 'hidden'}">

  <div class="row">
    <label class="col-lg-3">Total Users: {{table.totalRecords}}</label>
    <span class="col-lg-1"></span>
    <label class="col-lg-3">Selected Users: {{selectedUserCount}}</label>
    <span class="col-lg-1"></span>
  </div>

  <!-- compareSelectionBy="equals"  -->
  <p-table #table class="users-table" [value]="entries" dataKey="dataKey"
    [resizableColumns]="true"
    [scrollable]="true" scrollHeight="400px"
    [customSort]="true" (sortFunction)="doCustomSort($event)"
    [(selection)]="selectedUsers">

    <ng-template pTemplate="header">
      <tr>
        @if (maxUsers == 1) {
          <th class="uv-table-checkbox"></th>
        }
        @if (maxUsers > 1) {
          <th class="uv-table-checkbox">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
        }
        @for (col of cols; track col) {
          <th pResizableColumn [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
      </tr>
      <tr>
        <th class="uv-table-checkbox"></th>
        @for (col of cols; track col) {
          <th>
            <input #filter pInputText type="text" style="width: 100%;"
              (input)="table.filter($event.target.value, col.field, col.filterMatchMode)">
            </th>
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
          @if (maxUsers == 1) {
            <td class="uv-table-checkbox">
              <p-tableRadioButton [value]="rowData"></p-tableRadioButton>
            </td>
          }
          @if (maxUsers > 1) {
            <td class="uv-table-checkbox">
              <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
            </td>
          }
          @for (col of cols; track col) {
            <td>
              <span class="uv-table-value">{{rowData[col.field]}}</span>
            </td>
          }
        </tr>
      </ng-template>

    </p-table>

    <p-footer>
      <button type="button" pButton icon="fa fa-check" [disabled]="!isOkEnabled()"
      (click)="onOkClicked()" label="OK"></button>
      <button type="button" pButton icon="fa fa-times" [disabled]="false"
      (click)="onCancelClicked()" label="Cancel"></button>
    </p-footer>

  </p-dialog>